module.exports = __webpack_public_path__ + "images/emoji/train.3460111c4df415e87d51.png";